import ReportProvider from '@/resources/report_provider'
const reportProvider = new ReportProvider()

const state = {
  reportZ: {}
}

const actions = {
  async getReportZ ({commit}, payload) {
    commit('SET_REPORT_Z', await reportProvider.getReportZ(payload))
  }
}

const mutations = {
  SET_REPORT_Z (state, payload) {
    state.reportZ = payload
  }
}

const getters = {
  reportZ: (state) => {
    return state.reportZ
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js